import React from 'react';
import classnames from 'classnames';
import EventListener from 'fbjs/lib/EventListener';
import lodashThrottle from 'lodash/throttle';
import domHelperScrollTop from 'dom-helpers/query/scrollTop';

import '../styles/Introduction.css';

class Introduction extends React.Component {

  state = {
    showContacts: false
  };

  render() {
    return (
      <div className={classnames('Introduction', this.props.className)}>
        <h1 className="Introduction-title">
          {`Kyu Simm`}
        </h1>
        <p className="Introduction-description">
          {`I am a SF/Silicon Valley-based software engineer and a designer, working on `}<strong>{`a new initiative at Amazon`}</strong>{` in Palo Alto.`}
        </p>
        <div className="Introduction-school">
          <p>{`University of California, Berkeley`}</p>
          <p>{`Class of 2012, Computer Science`}</p>
        </div>
        <div
          className={classnames('Introduction-contacts', {
            visible: this.state.showContacts
          })}>
          <a
            className="Introduction-email"
            href="mailto:kyusimm@gmail.com">
          </a>
          <a
            className="Introduction-linkedIn"
            href="https://www.linkedin.com/pub/kyu-simm/31/36a/b55"
            target="_blank"
            rel="noopener noreferrer">
          </a>
        </div>
      </div>
    );
  }
  
  componentDidMount() {
    this._attachListeners();
  }

  componentWillUnmount() {
    this._detachListeners();
  }

  _attachListeners = () => {
    this._scrollListener = EventListener.listen(window, 'scroll', lodashThrottle(this._onScrollOrResize, 10));
    this._resizeListener = EventListener.listen(window, 'resize', lodashThrottle(this._onScrollOrResize, 50));

    this._onScrollOrResize();
  };

  _detachListeners = () => {
    if (this._scrollListener) {
      this._scrollListener.remove();
      this._scrollListener = null;
    }
    if (this._resizeListener) {
      this._resizeListener.remove();
      this._resizeListener = null;
    }
  };

  _onScrollOrResize = () => {
    const scrollTop = domHelperScrollTop(window);

    if (scrollTop > 320) {
      if (this.state.showContacts) {
        this.setState({
          showContacts: false
        });
      }
    } else {
      if (!this.state.showContacts) {
        this.setState({
          showContacts: true
        });
      }
    }
  };

}

export default Introduction;



// WEBPACK FOOTER //
// ./src/components/Introduction.js